// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InvoiceAuditList } from '@/billing/components/invoice-audit-list';
import { AuditDrawer } from '@/components/audit-drawer';
import { SupportErrorBoundary } from '@/components/support-error-boundary';
import { Suspense } from 'react';

interface Props {
  // Nano-id key of the invoice whose audit history to render. May be null
  // when the drawer is closed and no invoice has been selected yet.
  invoiceKey: string | null;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

/**
 * Side drawer that displays the chronological audit log for a single
 * invoice. Mirrors the ChargeAuditDrawer pattern so the shared AuditDrawer
 * chrome and Suspense fallbacks behave identically.
 */
export function InvoiceAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Invoice audit log"
      disclosure={props.disclosure}
      auditLog={
        <SupportErrorBoundary message="An error occurred while loading the audit log.">
          <Suspense>
            {props.invoiceKey !== null && (
              <InvoiceAuditList invoiceKey={props.invoiceKey} />
            )}
          </Suspense>
        </SupportErrorBoundary>
      }
    />
  );
}
